import React from "react";
import { FiTrash2 } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import MainButton from "../button/MainButton";

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  cancelLabel,
  icon,
  confirmVariant = "danger",
  cancelVariant = "secondary",
  confirmClassName = "bg-red text-white hover:opacity-90",
  cancelClassName = "bg-gray-200 text-darkGray hover:bg-gray-300",
}) {
  const { t } = useTranslation();

  const resolvedTitle = title ?? t("ACTIONS.CONFIRM");
  const resolvedDescription = description ?? t("MODAL.SURE");
  const resolvedConfirmLabel = confirmLabel ?? t("ACTIONS.CONFIRM");
  const resolvedCancelLabel = cancelLabel ?? t("ACTIONS.CANCEL");

  const resolvedIcon =
    icon ?? <FiTrash2 className="text-red text-xl" aria-hidden="true" />;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg px-8 py-7">
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full bg-red/10 flex items-center justify-center">
            {resolvedIcon}
          </div>

          <h2 className="mt-4 text-lg font-semibold text-darkGray">{resolvedTitle}</h2>
          <p className="mt-1 text-sm text-Gray">{resolvedDescription}</p>

          <div className="mt-6 flex w-full gap-3">
            <MainButton
              variant={cancelVariant}
              className="flex-1 rounded-lg px-6 py-2 text-sm font-medium"
              onClick={onClose}
            >
              {resolvedCancelLabel}
            </MainButton>

            <MainButton
              variant={confirmVariant}
              className="flex-1 rounded-lg px-6 py-2 text-sm font-medium"
              onClick={onConfirm}
            >
              {resolvedConfirmLabel}
            </MainButton>
          </div>
        </div>
      </div>
    </Modal>
  );
}